import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'
import { PageImageService } from '../Services/pageimage';
import { ImageUtils } from '../Services/imageutils';
import { PageImage } from '../Models/pageimage';
import { trigger, state, style, animate,
         transition } from '@angular/animations';


let SLIDE_TRANS = '1500ms ease-in-out'; // animation spec
let SLIDE_PAUSE = 7000; // ms


@Component({
  selector: 'carousel',
  templateUrl: '../Templates/carousel.html',
  styleUrls: ['../Styles/carousel.scss'],
  animations: [
    trigger('slide', [
      state('left', style({
        transform: 'translateX(-{{perc}}%)'
      }), {params: {perc: 0}}),
      state('right', style({
        transform: 'translateX({{perc}}%)'
      }), {params: {perc: 0}}),
      state('pause', style({
        transform: 'translateX(0)'
      })),
      transition('* => right', [
        animate(SLIDE_TRANS)
      ]),
      transition('* => left', [
        animate(SLIDE_TRANS)
      ]),
      transition('left => pause, right => pause', [
        style({transform: 'translateX(0)'})
      ])
    ])
  ]
})


export class CarouselComponent implements OnInit {

  public images: PageImage[] = [];
  public active_img: number = 0;
  private timer: any;
  public slide: string = "pause";
  private direction: string = "next";

  constructor(private pageImageService: PageImageService,
              private sanitizer: DomSanitizer,
              private imageUtils: ImageUtils) {
  }

  public getUrl(img) {
    return this.sanitizer.bypassSecurityTrustStyle(`url(${img.img})`);
  }

  ngOnInit() {

    this.pageImageService.list().subscribe(
      data => {
        this.images = data['results'] || [];
      }
    );

    if (this.timer) {
      clearInterval(this.timer);
    }

    this.timer = setInterval(() => { this.run() }, SLIDE_PAUSE);
  }

  /* Run on auto mode, untill someone hits the button.
   */
  run(): void {

    if (this.direction == "next") {
      if (this.hasNext()) {
        this.next(true);
      } else {
        this.direction = "previous";
        this.previous(true);
      }
    } else {
      if (this.hasPrevious()) {
        this.previous(true);
      } else {
        this.direction = "next";
        this.next(true);
      }
    }
  }

  next(auto?: boolean): void {

    if (this.timer && !auto) {
      clearInterval(this.timer);
    }

    this.slide = "left";
  }

  previous(auto?: boolean): void {

    if (this.timer && !auto) {
      clearInterval(this.timer);
    }

    this.slide = "right";
  }

  setActiveImg(idx: number): void {
    this.active_img = idx;
  }

  slideDone(event: any) {

    if (this.slide == "left") {
      if (this.active_img > this.images.length -1) {
        this.active_img = 0;
      } else {
        this.active_img++;
      }
    } else if (this.slide == "right") {
      if (this.active_img == 0) {
        this.active_img = this.images.length - 1;
      } else {
        this.active_img--;
      }
    }

    this.slide = "pause";
  }

  public hasNext() {
    return this.active_img < this.images.length - 1;
  }

  public hasPrevious() {
    return this.active_img > 0 && this.images.length;
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/carousel.ts